module.exports = __webpack_public_path__ + "img/projectNotice.a0b363d8.jpg";